const Report = () =>
  import(
    /* webpackChunkName: "financial-tariff-auction" */ '@/pages/financial/tariff/auction/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "financial-tariff-auction" */ '@/pages/financial/tariff/auction/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "financial-tariff-auction" */ '@/pages/financial/tariff/auction/edit.vue'
  )

export default {
  path: 'auction',
  meta: {
    label: 'auctiontariff',
    auth: 'auction'
  },
  component: {
    name: 'Auction',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialTariffAuctionReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'FinancialCreateTariffAuction',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'FinancialEditTariffAuction',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
